import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";  // Import for Authentication
//import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB3kh6GWY-XKfdAaULanMNx7YyIZFA-Yq0",
  authDomain: "fasttrack-8ffd1.firebaseapp.com",
  projectId: "fasttrack-8ffd1",
  storageBucket: "fasttrack-8ffd1.appspot.com",
  messagingSenderId: "82451150809",
  appId: "1:82451150809:web:f7059e83060c6a87494bc8",
  measurementId: "G-KV2NVB07RF"
};

// Initialize Firebase
let app;

if (!getApps().length) {
  app = initializeApp(firebaseConfig);
  //const analytics = getAnalytics(app);
} else {
  app = getApp(); // if already initialized, use that one
}

const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { auth, googleProvider };